import React, {
    useEffect,
    useState
} from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import whatsapp from '../assets/images/timeline/whatsapp.svg'
import Format from '../utils/format-text'
import { ChatHistory } from './../redux/actions/ChatActions'
import EventEmitter from './../utils/EventEmitter'
import { useDispatch, useSelector } from 'react-redux'
function DialogboxWa(props) {
    const [history, sethistory] = useState([])
    let agent = localStorage.getItem('user')
    let dispatch = useDispatch()
    useEffect(() => {
        if (props.open === true) {
            let data = {
                phone: props.phone_number,
                session_id: props.data.channel_id,
            }

            dispatch(ChatHistory(data)).then((response) => {
                if (response.data.statusCode === 200) {
                    sethistory([].concat(response.data.data))
                } else {
                    sethistory([])
                }
            }).catch((err) => {
                EventEmitter.emit('error-message-getter', {
                    action: 'fetch',
                    module: 'whatsapp conversation',
                })
            })
        }
    }, [props.open])
    return (
        <div>
            <Dialog
                open={
                    props.open
                }
                fullWidth={true}
            >
                <DialogTitle className="dialog-header-wa">
                    <div className='dialog-header-wa-flex'>
                        <>
                            <img
                                className="timeline-badge-image"
                                src={whatsapp}
                                alt="test"
                            />
                        </>
                        <>
                            {Format("Whatsapp Conversation")}
                        </>


                    </div>

                </DialogTitle>
                <DialogContent className="dialog-content">
                    <DialogContentText className={props.defaultclass}>
                        {history.length > 0 && (
                            <>
                                {history.map(
                                    (value, i) => {
                                        return (
                                            <div key={i}>
                                                {value.agent !==
                                                    agent &&
                                                    value.msg_direction ===
                                                    'out' && (
                                                        <div className="d-flex align-items-center justify-content-start">
                                                            <span className="chat-request">
                                                                {
                                                                    value.msg_text
                                                                }{' '}
                                                            </span>
                                                        </div>
                                                    )}

                                                {value.msg_direction ===
                                                    'in' && (
                                                        <div className="d-flex align-items-center justify-content-start">
                                                            <span className="chat-request chat-user">
                                                                {
                                                                    value.msg_text
                                                                }{' '}
                                                            </span>
                                                        </div>
                                                    )}

                                                {value.agent ===
                                                    agent &&
                                                    value.msg_direction ===
                                                    'out' && (
                                                        <div className="d-flex align-items-center justify-content-start flex-row-reverse">
                                                            <span
                                                                className="chat-response"
                                                                style={{
                                                                    paddingRight: 10,
                                                                }}
                                                            >
                                                                {
                                                                    value.msg_text
                                                                }{' '}
                                                            </span>
                                                        </div>
                                                    )}
                                            </div>
                                        )
                                    },
                                )}
                            </>
                        )}
                        {history.length === 0 && (
                            // history.length === 0 &&
                            <>
                                <div className="chat-nodata lead-wa-nodata">
                                    No Chat
                                </div>
                            </>
                        )}
                    </DialogContentText>
                </DialogContent>
                <div className="dialog-buttons">


                    <>
                        <button
                            className="dialog-btn1" style={{ "backgroundColor": "red" }}
                            onClick={() => {
                                props.close(false)
                            }}
                        >
                            Close
                        </button>

                    </>

                </div>
            </Dialog>
        </div>
    )
}

export default DialogboxWa
